import { awaitOnce2ui7qqi9bvdeq as awaitOnce } from '../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { modification1bed5xcrmg3fq as modification } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningdb/modification.diff.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  OnFieldsnrykjjrmtcs as OnField,
  Assign2nr5v5j409ffp as Assign,
  Chainlkbkk6tcx8wg as Chain,
} from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Modification.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_diff__qq3ja5(_this__u8e3s4, serializer, $completion) {
  var tmp = awaitOnce(_this__u8e3s4.aak(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = awaitOnce(_this__u8e3s4, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return modification(serializer, tmp, tmp_0);
}
function diff(_this__u8e3s4, serializer, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_diff__qq3ja5.bind(VOID, _this__u8e3s4, serializer), $completion);
}
function *_generator_pushChanges__njfm5x(_this__u8e3s4, cache, $completion) {
  var tmp = awaitOnce(_this__u8e3s4.aak(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var id = tmp.f40();
  var tmp_0 = awaitOnce(_this__u8e3s4, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var p = tmp_0;
  var temp = cache.geo(id);
  var tmp_1 = temp.iah(p, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = awaitOnce(temp, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var confirmed = ensureNotNull(tmp_2);
  var tmp_3 = _this__u8e3s4.aak().iah(confirmed, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  _this__u8e3s4.nai();
  return confirmed;
}
function pushChanges(_this__u8e3s4, cache, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_pushChanges__njfm5x.bind(VOID, _this__u8e3s4, cache), $completion);
}
function *_generator_pushChanges__njfm5x_0(_this__u8e3s4, cache, fields, $completion) {
  var tmp = awaitOnce(_this__u8e3s4.aak(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var published = tmp;
  var tmp_0 = _this__u8e3s4.bak($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var new_0 = tmp_0;
  var db = cache.geo(published.f40());
  var tmp_1 = awaitOnce(db, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if (tmp_1 == null) {
    var tmp_2 = db.iah(new_0, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    return new_0;
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = isInterface(fields, KtList()) ? fields : THROW_CCE();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$0;
    $l$block: {
      var o = element.k2j(published);
      var n = element.k2j(new_0);
      if (equals(o, n)) {
        tmp$ret$0 = null;
        break $l$block;
      }
      tmp$ret$0 = OnField().a44(element, Assign().l42(n));
    }
    var tmp0_safe_receiver = tmp$ret$0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  var mod = Chain().h42(destination);
  if (mod.f42())
    return new_0;
  var tmp_3 = db.nen(mod, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp0_elvis_lhs = tmp_3;
  return tmp0_elvis_lhs == null ? new_0 : tmp0_elvis_lhs;
}
function pushChanges_0(_this__u8e3s4, cache, fields, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_pushChanges__njfm5x_0.bind(VOID, _this__u8e3s4, cache, fields), $completion);
}
function *_generator_pushChanges__njfm5x_1(_this__u8e3s4, getCache, $completion) {
  var tmp = getCache($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = pushChanges(_this__u8e3s4, tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function pushChanges_1(_this__u8e3s4, getCache, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_pushChanges__njfm5x_1.bind(VOID, _this__u8e3s4, getCache), $completion);
}
function *_generator_updatePublished__vat9w1(_this__u8e3s4, value, serializer, $completion) {
  var tmp = awaitOnce(_this__u8e3s4.aak(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (equals(tmp, value))
    return Unit_instance;
  var tmp_0 = diff(_this__u8e3s4, serializer, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var mod = tmp_0;
  if (mod == null) {
    var tmp_1 = _this__u8e3s4.aak().iah(value, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    _this__u8e3s4.nai();
    return Unit_instance;
  }
  var tmp_2 = _this__u8e3s4.aak().iah(value, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = _this__u8e3s4.iah(mod.r3q(value), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function updatePublished(_this__u8e3s4, value, serializer, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_updatePublished__vat9w1.bind(VOID, _this__u8e3s4, value, serializer), $completion);
}
//region block: exports
export {
  pushChanges_0 as pushChanges2xw2hvtobowgv,
  pushChanges_1 as pushChanges2hvomzqg6xzor,
  pushChanges as pushChanges1lnw8bjwewvzf,
  updatePublished as updatePublished2dsy69cya4hmm,
};
//endregion

//# sourceMappingURL=Draft.ext.mjs.map
